import React, { useState } from "react";
import styles from "./PreviewNumber.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { useDispatch } from "react-redux";
import { setSelectedOptionsForFormula } from "redux/slices/scoringSlice";

const PreviewNumber = (props) => {
  // console.log('props', props)
  const [num, setNum] = useState(0);
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const value = Number(event.target.value); // Ensure `num` is a number
    setNum(value);
    dispatch(
      setSelectedOptionsForFormula({ id: props.id || props?._id, value })
    );
  };

  // Generate range as an array of numbers
  const range = Array.from(
    { length: props?.whenAnswerOutsideRange?.split("-")[1] - props?.whenAnswerOutsideRange?.split("-")[0] + 1 },
    (_, i) => Number(props?.whenAnswerOutsideRange?.split("-")[0]) + i
  );

  const isNumInRange = range.includes(num);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {(props?.instructions || props?.data?.media?.length) ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.inputcontainer}>
          <input
            className={styles.inputField}
            onChange={handleChange}
            type="number"
          />
        </div>
      </div>

      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length > 0 &&
            props?.data?.media.map((image, index) => (
              <img
                key={index}
                className={styles.imageStyle}
                src={image.path}
                alt="Preview"
              />
            ))}
        </div>
      )}

      {!isNumInRange &&
        props?.dependentField?.map((ele, index) => (
          <React.Fragment key={index}>
            {props?.renderContent(ele)}
          </React.Fragment>
        ))}
    </div>
  );
};

export default PreviewNumber;
